<template>
	<div>
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../../assets/images/htgl2.png" class="steps step1" v-if="status==1">
			<img src="../../../assets/images/htgl1.png" class="steps step2" v-if="status==2">
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"我知道了":"我知道了"}}
			</div>
         <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
		<breadcrumb :routerList="[{to:'/contract-list',title:'合同管理'},{title:'新建线下合同'}]"/>
		<div class="h-content" :class="{'ljjtips':true}">
			<div class="h-piece">
        <div class="outerCon">
          <div class="tabBtn" :class="{tabBtnAc:tabIndex == '1'}" @click="tabchange(1)">合同</div>
          <div class="tabBtn" :class="{tabBtnAc:tabIndex == '2'}" @click="tabchange(2)">关联回款</div>
          <div class="tabBtn" :class="{tabBtnAc:tabIndex == '3'}" @click="tabchange(3)">关联订单</div>
        </div>
				<div class="h-formLine weekplandetail23" v-show="tabIndex == '1'">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                        <h1>合同详情</h1>
                    </div>
					<el-form label-position="right" :model="formInline" ref="form1" :rules="rules" :inline="true"  class="demo-ruleForm h-formbLine">
						<el-form-item label="合同编码" class="h-elformWrap-2" prop="id">
						<el-input v-model="formInline.id" placeholder="请输入合同名称" :disabled="disabled"></el-input>
					  </el-form-item>
                        <el-form-item label="合同名称" class="h-elformWrap-2">
                            <el-input readonly v-model="formInline.contractName"></el-input>
                        </el-form-item>
                    <el-form-item :label="customerlabel" class="h-elformWrap-2" prop="customerName">
                      <el-input v-model="formInline.customerName" @change="fillCusCode" :disabled="disabled" placeholder="请输入经销商名称"></el-input>
                    </el-form-item>

                        <el-form-item label="销售省区" class="h-elformWrap-2 w-elformWrap" prop="saleareaCode">
                            <brselect category="YlSalesArea_chanpin" :v="formInline.saleareaCode"
                                      v-model="formInline.saleareaCode" :disabled="disabled"></brselect>
                        </el-form-item>
                        <el-form-item label="销售地市" class="h-elformWrap-2 w-elformWrap" prop="salesCity" >
                            <el-select :multiple="true"
                                       :clearable="true"
                                       v-model="formInline.salesCity"
                                       :disabled="disabled"
                                       :v="formInline.salesCity">
                                <el-option v-for="item in salesCity"
                                           :key="item.index"
                                           :value="item.code"
                                           :label="item.name"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="质保期(月)" class="h-elformWrap-2 h-moneyIcon" prop="contractAmount" >
                            <el-input v-model.number="formInline.guaranteeTime" :disabled="disabled"  placeholder="请输入数字"></el-input>
                        </el-form-item>
                        <el-form-item label="合同金额(元)" class="h-elformWrap-2 h-moneyIcon" prop="contractAmount">
                            <el-input v-model.number="formInline.contractAmount" :disabled="disabled"  placeholder="请输入数字"></el-input>
                        </el-form-item>
                        <el-form-item label="回款模式" class="h-elformWrap-2" prop="contractAmount">
                            <el-input v-model="formInline.rentPlace" :disabled="disabled"  type="text"></el-input>
                        </el-form-item>

          </el-form>
                  <div class="h-formLine h-mrt40 weekplandetail1">
                    <el-form label-position="right" :model="file" :rules="rules" :inline="true"  class="demo-ruleForm h-formbLine">
                      <el-form-item label="合同附件" class="h-elformWrap-1 h-formRbtnOut h-formRbtnOut2" style="width: 100%;" prop="name">
                        <brupload :refid="this.contractId" reftype="合同附件" :uploadflag="false" :delflag="false"
                                  :tpFlag = 'true' :isTpAndPdf = 'true'
                        ></brupload>
                      </el-form-item>
                    </el-form>
                  </div>
          <div style="text-align: center;margin-top: 0.3rem">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
            <el-button class="h-btn h-bBtn" @click="viewpress">
              审批跟踪
            </el-button>
          </div>
        </div>
        <div class="h-formLine weekplandetail" v-show="tabIndex == '2'">
          <div>
            <el-button v-if="'0' == formInline.status" style="background-color: #2785e7;color: #edf0f5;margin-bottom: 10px" @click="userReceDomestic">回款认领</el-button>
          </div>
          <div class="h-piece">
            <div class="h-formBox">
              <el-form :inline="true" :model="claimRecordFrom" class="demo-form-inline h-formBorder" ref="form">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="凭证编号">
                    <el-input v-model="claimRecordFrom.belnr" clearable placeholder="请输入"></el-input>
                  </el-form-item>
                  <el-form-item label="凭证类型">
                    <el-input v-model="claimRecordFrom.blart" clearable placeholder="请输入"></el-input>
                  </el-form-item>
                  <el-form-item label="公司代码">
                    <el-input v-model="claimRecordFrom.bukrs" clearable placeholder="请输入"></el-input>
                  </el-form-item>
                  <el-form-item label="认领人">
                    <el-input v-model="claimRecordFrom.claimUserCode" clearable placeholder="请输入名称或工号"></el-input>
                  </el-form-item>
                  <el-form-item class="right-btn">
                    <el-button class="h-btn h-formBtn" @click="selectPageAll">检索</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
          <el-table
              :data="tableData"
              :border="true"
              max-height="560"
              style="width: 100%">
            <el-table-column
                label="序号"
                type="index"
                fixed
                width="50">
            </el-table-column>
            <el-table-column prop="belnr" label="凭证编号" width="150px"></el-table-column>
            <el-table-column prop="blart" label="凭证类型" width="90px"></el-table-column>
            <el-table-column prop="bukrs" label="公司代码" width="90px"></el-table-column>
            <el-table-column prop="waers" label="货币类型" width="90px"></el-table-column>
            <el-table-column prop="budat" label="凭证过账日期" width="90px" :formatter="formatDatecc"></el-table-column>
            <el-table-column prop="gjahr" label="会计年度" width="90px"></el-table-column>
            <el-table-column prop="wrbtr" label="金额" width="100px"></el-table-column>
            <el-table-column prop="claimWrbtr" label="已认领金额" width="100px"></el-table-column>
            <el-table-column prop="surplusWrbtr" label="剩余金额" width="100px"></el-table-column>
            <el-table-column prop="claimUserName" label="认领人" width="110px"></el-table-column>
            <el-table-column prop="claimDate" label="认领时间" width="140px" ></el-table-column>
          </el-table>
          <div class="h-tableB h-mrt30">
            <div class="h-pagination2">
              <pagination :page="claimRecordFrom" @query="selectPageAll"/>
            </div>
          </div>
          <div style="text-align: center;margin-top: 0.3rem">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
          </div>
        </div>
        <div class="h-formLine weekplandetail" v-show="tabIndex == '3'">
          <div class="h-piece" style="padding: 10px">
            <el-form :inline="true" :model="contractOrderFrom" class="demo-form-inline h-formBorder">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="订单号">
                  <el-input v-model="contractOrderFrom.sapCode" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="产品编码">
                  <el-input v-model="contractOrderFrom.productId" clearable placeholder="请输入产品编码或名称"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select v-model="contractOrderFrom.type" placeholder="请选择" clearable>
                    <el-option label="采购" value="1"></el-option>
                    <el-option label="销售" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="创建人">
                  <el-input v-model="contractOrderFrom.cucode" clearable placeholder="请输入创建人工号或名称"></el-input>
                </el-form-item>
                <el-form-item class="right-btn">
                  <el-button class="h-btn h-formBtn" @click="contractOrderPage">检索</el-button>
                </el-form-item>
              </div>
            </el-form>
            <span style="color: red;font-size: 10px;margin-left: 20px">注：查询多个订单号请使用"/"隔开</span>
          </div>
          <el-table :data="contractOrderData" :border="true" max-height="560" style="width: 100%" show-summary :summary-method="getSummaries" ref="multipleTable">
            <el-table-column label="序号" type="index" fixed width="50"></el-table-column>
            <el-table-column prop="ccode" label="合同编号" width="110px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="sapCode" label="订单号" width="110px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productId" label="产品编码" width="110px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productName" label="产品名称" width="110px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="startTime" label="质保开始时间" width="110px" :formatter="formatDatecc"></el-table-column>
            <el-table-column prop="endTime" label="质保结束时间" width="110px" :formatter="formatDatecc"></el-table-column>
            <el-table-column prop="zhibaoStatus" label="质保状态" width="90px" ></el-table-column>
            <el-table-column prop="orderStatus" label="订单状态" width="90px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="yanshouStatus" label="验收状态" width="90px" ></el-table-column>
            <el-table-column prop="proNumber" label="订单数量" width="90px"></el-table-column>
            <el-table-column prop="totalprice" label="订单总价" width="90px"></el-table-column>
            <el-table-column prop="cuname" label="创建人名称" width="90px"></el-table-column>
            <el-table-column prop="cdate" label="创建时间" width="110px" :formatter="formatDatecc"></el-table-column>
            <el-table-column prop="type" label="类型" width="90px" >
              <template scope="scope">
                <span>
                  {{'1' == scope.row.type ? '采购' :'2' == scope.row.type ? '销售' : ''}}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="h-tableB h-mrt30">
            <div class="h-pagination2">
              <pagination :page="contractOrderFrom" @query="contractOrderPage"/>
            </div>
          </div>
        </div>
        <el-dialog :close-on-click-modal="false"  :visible.sync="visible" custom-class="body_dilog">
          <div class="h-rowIn" >
            <div class="h-rowBox">
              <div class="h-rowCon">
                <div class="h-formBox" style="margin-bottom: 1px;">
                  <el-form :inline="true" :model="modelUserCode" class="demo-form-inline h-formBorder">
                    <el-form-item label="凭证编号">
                      <el-input clearable v-model="modelUserCode.belnr"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary"  icon="el-icon-search" @click="userReceDomestic">搜索</el-button>
                    </el-form-item>
                    <el-row>
                      <el-form-item class="h-formBtnOut">
                        <el-button type="primary" @click="selectUser">确认认领</el-button>
                        <br />
                        <span style="color: red">请先勾选凭证编号并填写认领金额后再点击确认认领</span>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
                <el-table
                    max-height="500px"
                    size="mini"
                    ref="multipleTable"
                    :data="ttdata"
                    border
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
                  <el-table-column
                      type="selection"
                      fixed
                      width="55">
                  </el-table-column>
                  <el-table-column
                      fixed
                      prop="belnr"
                      label="凭证编号"
                      width="100">
                  </el-table-column>
                  <el-table-column
                      prop="wrbtr"
                      label="金额">
                  </el-table-column>
                  <el-table-column
                      prop="surplusWrbtr"
                      label="剩余金额">
                  </el-table-column>
                  <el-table-column
                      prop="claimCurrent"
                      label="认领金额"
                      width="100">
                    <template slot-scope="scope">
                      <el-input :disabled="0 == scope.row.surplusWrbtr ? true:false" v-model="scope.row.claimCurrent" @blur="inputBlur(scope.row)"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="blart"
                      label="凭证类型"
                      width="50">
                  </el-table-column>
                  <el-table-column
                      prop="bukrs"
                      label="公司代码">
                  </el-table-column>
                  <el-table-column
                      prop="waers"
                      label="货币类型"
                      :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.waers | dictname('YLCurrency') }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="budat"
                      label="凭证过账日期"
                      :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column
                      prop="gjahr"
                      label="会计年度">
                  </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                  <paginationmin :page="modelUserCode" @query="userReceDomestic"/>
                </div>
              </div>
            </div>
          </div>
        </el-dialog>
		  </div>

    <viewhistory :visible.sync="showhistory" v-if="showhistory"
                 :id="instid"/>
    </div>

	</div>
</template>

<script>
	import big from 'big.js';
	import ss from "../../../api/SystemService";
	import util from "../../../utils/util";
    export default {
        name:'leftMenu',
        data() {
            return {
				// 新手引导页
				toshow:"contract-agent.vue",
				checked:true,
				status:1,
				showOrhide:false,
        contractId:null,
        guanlianxiangmFlag:true,

        optionsProduct2_jzx:[],
				optionsProduct2:[],
				optionsProduct1:[],
        lianqunList:[],
        qudao:[],
				customerlabel:"客户名称",
				allProjectByUser:[],
				tempProject:[],
				tempProject2:[],
                tableData2:[],
                tableData3:[],
                contarctAddList:[{
                    id:null,
                    contractId:null,
                    type:null,
                    starttime:null,
                    endtime:null,
                    status:null,
                    instid:null,
                    refid:this.$util.getUuid(),
                }],
                contarctAdd:{
                    id:null,
                    contractId:null,
                    saleareaCode:null,
                    type:null,
                    starttime:null,
                    endtime:null,
                    status:null,
                    instid:null,
                    refid:null,
                    contarctAddLists:[],
                },
				zlflag:false,
				bzflag:false,
				dlsflag:false,
                uploaddownexcelflag:false,
                showhistory:false,
				pickerOptions1:{
					disabledDate: (time)=>{
						if (this.formInline.contractEndtime != "") {
							return time.getTime() > this.formInline.contractEndtime;
						}
					}
				},
                q2:{
                    pageSize:10,
                    pageNo:1,
                    total:0,
                    contractId:null,
                    customerName:null
                },
                q3:{
                    pageSize:10,
                    pageNo:1,
                    total:0,
                    contractId:null,
                    agentNameLike:null,
                    year: 2024,
                },
				pickerOptions2:{
					disabledDate: (time)=>{
						if (this.formInline.contractStarttime != "") {
							return time.getTime() < this.formInline.contractStarttime;
						}
					}
				},
				//表单
				formInline:{
            zltype:"",
            contractName:null,
            pid:"",
            customerCode:"",
            salechannelCode:null,
            contractCatecory:"CT-DLS-KJ",
            contractAmount:"",
            contractStatus:"",
            contractStarttime:"",
            contractEndtime:"",
            contractCashPledge:"",
            productCode:"",
            productName:"",
            productPrice:"",
            productType:"",
            rentNum:"",
            rentTime:"",
            guaranteeTime:"",
            productList:[],
            zsyzq:"",
            rentType:"",
            isShhm:0,
            isJj:0,
            rentPlace:"",
            returnPlace:"",
            rentPrice:"",
            contractAgent:"",
            auditMind2:"",
            status:"",
            isZc:"",
            saleareaCode:null,
            bscContractAgentAddList:[],
            salesCity:"",
				},
              contractOrderData:[],
              contractOrderFrom:{
                //合同编码
                cCode:this.$route.query.key,
                //产品编码或名称
                productId:null,
                //创建人工号或名称
                cucode:null,
                //订单号
                sapCode:null,
                //类型
                type:null,
                pageSize: 10,
                pageNo: 1,
                total: 0,
              },
              tableData:[],
              claimRecordFrom:{
                //客户编码
                receUsercode:null,
                //认领人名称或者工号
                claimUserCode:null,
                belnr:null,
                blart:null,
                bukrs:null,
                pageSize: 10,
                pageNo: 1,
                total: 0,
              },
              modelUserCode:{
                receUsercode:null,
                belnr:null,
                pageSize: 10,
                pageNo: 1,
                total: 0,
              },
              ttdata:[],
              visible:false,
              resultData:[],
				formInline1:{
					wuliufangshi:2,
					condition:[]
				},
				customerList: [],
				//多选
				checkList:[],
				fileList:[],
        salesCity:[],
        channels:null,
        chakan:false,
        isCt:false,
				file:{
                    name:''
                },
				rules:{
					contractName: [
						{ required: true, message: '请输入合同名称', trigger: 'blur' },
					],
					contractCatecory: [
						{ required: true, message: '请选择合同类型', trigger: 'change' },
					],
					contractStarttime: [
						{ required: true, message: '请输入合同开始时间', trigger: 'blur' },
					],
					contractEndtime: [
						{ required: true, message: '请输入合同结束时间', trigger: 'blur' },
					],
				},
				jzxFlag:false,
				rentTimeList:[],
                contractSonList:[],
        taskid:null,
        Instid:null,
                isXy:null,
                tabIndex:null,
        disabled:false,
              fileFlag:true,
              daquflag:false,
              lastflag:false,

      }
    },
      methods: {
        save(){
          this.formInline.editStatus = 0;
          var cond = this.formInline1.condition;
          this.formInline.payCondition = cond.join(",");
          this.formInline.contractType = 0;
          this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
          this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
          this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
          if(cate == "CT-ZL" && this.formInline.zltype == '3'){
            var totalMoney = new big(0);
            if(this.formInline.zlList){
              this.formInline.zlList.forEach((obj)=>{
                totalMoney = totalMoney.plus(new big(obj.productTotalPrice));
              })
            }
            this.formInline.contractAmount = totalMoney;
          }
          this.formInline.zlList = this.formInline.zlList;
          ss.contractService.insertAgent(this.formInline).then(rd=>{
            if(rd.f){
              this.$msg.msgs("保存成功！");
              this.$router.push("contract-list");
            }else{
              this.$msg.msgs("保存失败！"+rd.msg);
            }
          });
        },
          viewpress() {
            this.instid = this.formInline.instid
              this.showhistory = true;
          },
        submit(rd){
          var subflag1 = false;
          this.$refs['form1'].validate((valid) => {
            if (valid){
              subflag1=true;
            }else{
              this.$msg.msge("请完善合同信息后再提交！");
              return false;
            }
          });
          if (!subflag1) {
            return;
          }
          console.log("节点",1)
          var cate = this.formInline.contractCatecory;
          this.$msg.confirm("确定要提交吗？",()=>{
            this.formInline.isZc = rd;
            this.formInline.editStatus = 1;
            this.formInline.contractType = 0;
            this.formInline.contractStarttime = this.formatDate(this.formInline.contractStarttime);
            this.formInline.contractEndtime = this.formatDate(this.formInline.contractEndtime);
            this.formInline.wuliufangshi = this.formInline1.wuliufangshi;
            console.log(1211,this.formInline);
              ss.contractService.insertAgent(this.formInline).then(rd=>{
                if(rd.f){
                  this.$msg.msgs("提交成功！");
                  this.$router.push("contract-list");
                }else{
                  this.$msg.msgs("提交失败！"+rd.msg);
                }
              })
            })
          },
          isEmpty(attr) {
            if (attr == null || attr == "") {
              return true;
            } else {
              return false;
            }
          },
          isNotEmpty(attr) {
            if (attr != null && attr != "") {
              return true;
            } else {
              return false;
            }
          },
          changeCatogory(attr){

          },
          formatDate(date){
            if (this.isNotEmpty(date)) {
              function addDateZero(num) {
                return (num < 10 ? "0" + num : num);
              }
              let d = new Date(date);
              let format = d.getFullYear()+"-"+addDateZero(d.getMonth()+1)+"-"+addDateZero(d.getDate());
              return format;
            }
          },
          daquPass(query){
            this.formInline.aaa = query;
            ss.contractService.daquPass(this.formInline).then(rd=>{
              this.$msg.alerts("提交成功！", () => {
                //刷新右上角的代办个数
                this.$store.dispatch("searchTasktotal")
                //跳转回系统的代办列表
                this.$router.push({
                  path: '/personal/dealCenter'
                })
              })
            })
          },
        contractPass(query){
          this.formInline.aaa = query;
          this.formInline.taskid = this.taskid;
          ss.contractService.hhContractPass(this.formInline).then(rd=>{
            this.$msg.alerts("提交成功！", () => {
              //刷新右上角的代办个数
              this.$store.dispatch("searchTasktotal")
              //跳转回系统的代办列表
              this.$router.push({
                path: '/personal/dealCenter'
              })
            })
          })
        },

        //查询渠道
        selectChannel() {
          ss.Dictservice.listbycategory("sales_region").then(response => {
            this.qudao = response;
          })
        },
        lianqunOptions(value){
          console.log("value",value);
          var jsonObj = value
          var jStr = '';
          for(var item in jsonObj){
            jStr += jsonObj[item]+",";
          }
          this.formInline.lianqun = jStr.substring(0, jStr.lastIndexOf(','))
          console.log(this.formInline.lianqun);
        },
        getQudao(value){
          console.log(value);
          var jsonObj = value
          var jStr = '';
          for(var item in jsonObj){
            jStr += jsonObj[item]+",";
          }
          this.channels = jStr.substring(0, jStr.lastIndexOf(','))
        },
        getLianquns(s){
          var m  = s.split(',');
          if(m.length<=0){
            this.lianqunList = ''
          }else {
            this.lianqunList = m
          }
          if(this.formInline.lianqun.includes("X02") || this.formInline.lianqun.includes("X01")
              || this.formInline.lianqun.includes("X08") || this.formInline.lianqun.includes("X09") || this.formInline.lianqun.includes("X10")
              || this.formInline.lianqun.includes("X05") || this.formInline.lianqun.includes("X06")
          ){
            this.isCt = true;
          }else {
            this.isCt = false;
          }
        },
			// 关闭新手引导页
			closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
			},
        fillCusCode(){
          this.formInline.customerCode = this.formInline.customerName;
        },
			nextStep(i){
				if(this.status ==1){
						this.status = 2;
				}else if(this.status ==2){
					if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			},
			// 时间戳转换日期
			timestampToTime(timestamp) {
			  var  date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
			  let Y = date.getFullYear() ;
			  let M = (date.getMonth()+1 < 10 ?  '0' +(date.getMonth()+1) : date.getMonth()+1) ;
			  let D = date.getDate().toString().padStart(2,0);
			  let h = date.getHours() +  ':' ;
			  let m = date.getMinutes() +  ':' ;
			  let s = date.getSeconds();
			  return  Y + '-' + M + '-' + D;//+h+m+s
			},
			/**
			 * 查询当天日期
			 */
			// getNowDate(d) {
			//   const timeOne = new Date()
			//   const year = timeOne.getFullYear()
			//   let month = timeOne.getMonth() + 1
			//   let day = timeOne.getDate()
			//   month = month < 10 ? '0' + month : month
			//   day = day < 10 ? '0' + day : day
			//   const NOW_MONTHS_AGO = `${year}-${month}-${day}`
			//   return NOW_MONTHS_AGO
			// },
			stRentTime(){
			  let that = this;
			  that.formInline.contractStarttime = that.timestampToTime(new Date().getTime());// 默认开始日期
			  that.formInline.contractEndtime = that.timestampToTime(new Date().getTime()+that.formInline.rentTime*24*60*60*1000);// 默认结束日期
				for(var i = 0;i < this.rentTimeList.length;i++){
					var priceData = this.rentTimeList[i];
					if(priceData.rentTerm == this.formInline.rentTime){
						that.formInline.rentPrice = priceData.rentPrice;
						if(this.formInline.zlList){
							for(var j = 0;j < this.formInline.zlList.length;j++){
								var zl = this.formInline.zlList[j];
								if(zl.priceType == 'ZL01'){
									zl.productUnitPrice = priceData.rentPrice;
								}
							}
						}
					}
				}
			},
			setZlDate(){
				let that = this;
				var newDate = new Date(that.formInline.contractStarttime);
				that.formInline.contractEndtime = that.timestampToTime(newDate.getTime()+that.formInline.rentTime*24*60*60*1000-24*60*60*1000);// 默认结束日期
			},
          setAddDate(index){
              let that = this;
              var newDate = new Date(that.contarctAddList[index].starttime);
              that.contarctAddList[index].endtime = that.timestampToTime(newDate.getTime()+that.formInline.rentTime*24*60*60*1000-24*60*60*1000);// 默认结束日期
          },
        cancel(){
          this.$router.push("contract-list");
        },
        getCity(s){
          var s1 = s;
          var m  = s1.split(',');
          if(m.length<=0){
            this.formInline.salesCity = ''
          }else {
            this.formInline.salesCity = m
          }
        },
        getAreaCity(){
          let areas = this.formInline.saleareaCode.split(",");
          let ss1 = [];
          let promises = []; // 创建一个存储异步操作的Promise数组
          for (var i = 0; i < areas.length; i++) {
            let promise = ss.Dictservice.getDictByCateCode("YlSalesArea_chanpin", areas[i])
                .then(response => {
                  ss1.push(response.refid);
                });
            promises.push(promise); // 将每个异步操作的Promise添加到数组中
          }

          Promise.all(promises) // 等待所有异步操作完成
              .then(() => {
                var s2 = ss1.join(",");
                ss.UserService.getCityByArea(s2).then(rd => {
                  this.salesCity = rd.msg;
                });
              });
        },
          //框架合同table页
          tabchange(i) {
              console.log(i);
              this.tabIndex = i;
              if (this.tabIndex == '1') {
                  this.tabflag = true;
              } else if (this.tabIndex == '3') {
                  this.tabflag = true;
              } else if (this.tabIndex == '2') {
                  this.tabflag = true;
              }
          },
          selectPageAll() {
            ss.claimRecord.selectPage(this.claimRecordFrom).then(res => {
              this.claimRecordFrom.total = res.total;
              this.tableData = res.records;
            })
          },
          queryMb() {
                this.q3.agentNameLike = this.formInline.customerName;
              this.q3.salesRegionCode = this.formInline.salechannelCode;
              ss.fanli.pagefanliXsjl(this.q3).then(rd=>{
                  this.q3.total = rd.total;
                  this.tableData3 = rd.records;
              });

          },
          getContarctSon(v){
              ss.contractService.getContractSon(v).then(rd => {
                  this.contractSonList = rd.msg;
              })
          },
          checkSon(id){
              this.$router.push({path:"/contract-agent-see", query:{key: id}})
          },
          addXyList(){
              this.contarctAddList.push({
                  id:null,
                  contractId:null,
                  type:null,
                  starttime:null,
                  endtime:null,
                  status:null,
                  instid:null,
                  refid:this.$util.getUuid(),
              })
          },
          deleteXyList(){
              if(this.contarctAddList.length != 1){
                  this.contarctAddList.splice(this.contarctAddList.length-1, 1)
              }
          },
          submitAgentAdd(){
              this.$msg.confirm("确定要提交吗？",()=>{
                  this.contarctAdd.contarctAddLists = this.contarctAddList;
                  this.contarctAdd.contractId = this.formInline.id;
                  this.contarctAdd.saleareaCode = this.formInline.saleareaCode;
                  ss.contractService.insertAgentAdd(this.contarctAdd).then(rd=>{
                      if(rd.f){
                          this.$msg.msgs("提交成功！");
                          this.$router.push("contract-list");
                      }else{
                          this.$msg.msgs("提交失败！"+rd.msg);
                      }
                  })
              })
          },
        /**
         * 弹框回款信息搜索
         */
        userReceDomestic(){
          console.log(this.formInline.customerCode)
          if (this.formInline.customerCode){
            this.modelUserCode.receUsercode = this.formInline.customerCode;
            ss.claimRecord.selectClaimPage(this.modelUserCode).then(res => {
              this.modelUserCode.total = res.total;
              this.ttdata = res.records;
              this.visible = true;
            }).catch((error) => {
              this.$alert("获取信息失败，请联系系统管理员", '提示', {
                confirmButtonText: '确定',
                type:'error',
              });
            });
          }else {
            this.$alert("合同缺少客户编码信息，请联系系统管理员", '提示', {
              confirmButtonText: '确定',
              type:'error',
            });
          }
        },
        /**
         * 回款认领弹框确认认领按钮
         */
        selectUser(){
          if (this.resultData.length > 0){
            ss.claimRecord.saveClaimRecord(this.resultData).then(res => {
              console.log(res)
              if (res.f){
                this.$alert("保存成功", '提示', {
                  confirmButtonText: '确定',
                  type:'success',
                });
                this.visible = false;
                this.selectPageAll();
              }
            }).catch((error) => {
              this.$alert("领取失败，请联系系统管理员", '提示', {
                confirmButtonText: '确定',
                type:'error',
              });
            });
          }else {
            this.$alert("请选择需要认领的凭据编号", '提示', {
              confirmButtonText: '确定',
              type:'warning',
            });
          }
        },
        /**
         * 勾选弹框列表数据
         * @param resultData
         */
        handleSelectionChange(resultData){
          this.resultData = resultData;
          console.log(resultData)
        },
        /**
         * 校验认领金额
         * @param row
         */
        inputBlur(row){
          console.log(row)
          const regex = /^\d+(\.\d+)?$/;
          if (row.claimCurrent){
            if (!regex.test(row.claimCurrent)){
              this.$alert("录入金额有误，请重新录入", '提示', {
                confirmButtonText: '确定',
                type:'error',
              });
              for (let i = 0; i < this.ttdata.length; i++) {
                if (row.belnr == this.ttdata[i].belnr){
                  //录入金额有问题，清除
                  this.ttdata[i].claimCurrent = '';
                  break
                }
              }
              return
            }
            if (row.claimCurrent > row.surplusWrbtr){
              //如果认领金额大于剩余金额，清除
              this.$alert("认领金额大于剩余金额，请重新录入", '提示', {
                confirmButtonText: '确定',
                type:'error',
              });
              for (let i = 0; i < this.ttdata.length; i++) {
                if (row.belnr == this.ttdata[i].belnr){
                  //录入金额有问题，清除
                  this.ttdata[i].claimCurrent = '';
                  break
                }
              }
              return
            }
          }
        },
        /**
         * 凭证过账日期格式化
         * @param row
         * @param column
         * @returns {string|null}
         */
        formatDatecc(row, column) {
          // 获取单元格数据
          let data = row[column.property]
          if(data == null || data == '') {
            return null
          }
          let dt = new Date(data)
          return this.$util.riQi3(dt);
        },
        /**
         * 关联订单信息查询
         */
        contractOrderPage(){
          ss.claimRecord.contractOrderPage(this.contractOrderFrom).then(res => {
            this.contractOrderFrom.total = res.total;
            this.contractOrderData = res.records;
          })
        },
        getSummaries(param){
          const { columns, data } = param;
          const sums = [];
          columns.forEach((column, index) => {
            if (index === 0) {
              sums[index] = '合计';
              return;
            }
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              if (10 == index || 11 == index){
                sums[index];
              }else {
                sums[index] = '';
              }
            } else {
              sums[index] = '';
            }
          });

          return sums;
        },
		},
      mounted() {
            if (this.contractId != null) {
              this.disabled = true;
              ss.contractService.detail(this.contractId).then(rd=>{
                this.guanlianxiangmFlag = false;
                this.formInline = rd.obj;
                if (rd.obj.customerCode){
                  this.claimRecordFrom.receUsercode = rd.obj.customerCode;
                  this.selectPageAll();
                }
                this.contractOrderPage();
                this.formInline.id = this.contractId;
                if(this.formInline.lianqun != null && this.formInline.lianqun){
                  let s = this.formInline.lianqun;
                  this.getLianquns(s)
                }
                if(this.formInline.salesCity != null && this.formInline.salesCity){
                  let s = this.formInline.salesCity;
                  this.getCity(s);
                  this.getAreaCity();
                }
              })
            }
      },
      created() {
        this.instid = this.$route.query.instid;
        this.isXy = this.$route.query.isXy;
         this.taskid = this.$route.query.taskid;
          this.contractId = this.$route.query.key;
        this.selectChannel();
        this.tabIndex = '1';
        if(null != this.instid && this.instid != ''){
          this.disabled = true;
          //根据instid查询数据
            ss.contractService.getContractByInstid(this.instid).then(rd => {
                console.log('rdrdrd',rd)
                if(rd.f){
                    this.formInline = rd.msg;
                    this.contractId = this.formInline.id;
                }
            })
        }
      }
    }
</script>

<style>
/* .h-formbLine .el-form-item__label{
	width: 18%;
} */
.yearIcon .el-input:after {
  content: '天';
  font-size: 0.18rem;
  color: #b8b6b6;
  /* font-weight: bold; */
  position: absolute;
  right: 0.15rem;
}
.weekplandetail1 .h-formbLine .el-form-item__label{
	width: 11%;
	text-align: right;
}
.weekplandetail23 .h-formbLine .el-form-item__label{
	width: 34%;
	text-align: right;
}
.weekplandetail23 .h-formbLine .el-form-item__content{
	width: 66%;
}
.weekplandetail23 .h-formbLine .h-elformWrap-2{
	width: 33.333%;
	padding-right: 0.5rem
}
.weekplandetail23 .h-formbLine .h-elformWrap-1{
	width: 100%;
	padding-right: 0.5rem
}
.weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__label{
	width: 10.4%;
}
.weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__content{
	width: 89.6%;
}
.ljjtips .el-table tbody td .cell{
	padding: 0.2rem 0.1rem;
}
.outerCon {
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #dae0f0;
    width: 100%;
    margin-bottom: 30px;


.tabBtn {
    background-color: #f0f5fb;
    padding: 10px;
    border: 1px solid #dae0f0;
    margin-right: 10px;
    color: #282c2f;
    cursor: pointer;
}

.tabBtnAc {
    color: white;
    background-color: #2785e7;
}
.foundation-box{
    font-size: 0.18rem;
    color: #868686;
    line-height: 0.28rem;
}
.signsign .h-formbLine .el-form-item__label {
    width: 39%;
}

.zhanghu .h-formbLine .el-form-item__content,
.signsign .h-formbLine .el-form-item__content {
    width: 52%;
}

.zhanghu .h-formbLine .h-elformWrap-2,
.signsign .h-formbLine .h-elformWrap-2 {
    width: 25%;
    padding-right:0
}

}
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 2.6rem;
			left: 3.15rem;
			width: 4rem;
			height: 1.7rem;
		}
		.step2{
			top: 4.55rem;
			left: 3.9rem;
			width: 13.5rem;
			height: 2.3rem;
		}

		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
